import React, {useEffect} from 'react';
import {CropPresetBtns} from './crop-preset-btns';
import {state, tools} from '@app/state/utils';

export function CropNav() {
  useEffect(() => {
    state().setDirty(true);
    tools().frame.active.hide();
    return () => {
      tools().frame.active.show();
    };
  }, []);

  return (
    <CropPresetBtns />
  );
}
